import { CHANNEL_CACHE, TOKEN_KEY } from "./Config";

// @ts-ignore
Date.prototype.format = function (fmt) {
    let o = {
        "M+": this.getMonth() + 1,                 //月份
        "d+": this.getDate(),                    //日
        "h+": this.getHours(),                   //小时
        "m+": this.getMinutes(),                 //分
        "s+": this.getSeconds(),                 //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (let k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            // @ts-ignore
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
};

export function getQueryString(url?: string): any {
    const d = decodeURIComponent;
    let queryString = url ? url.split('?')[1] : window.location.search.slice(1);
    const obj: any = {};
    if (queryString) {
        queryString = queryString.split('#')[0]; // eslint-disable-line
        const arr = queryString.split('&');
        for (let i = 0; i < arr.length; i += 1) {
            const a = arr[i].split('=');
            let paramNum;
            const paramName = a[0].replace(/\[\d*\]/, (v) => {
                paramNum = v.slice(1, -1);
                return '';
            });
            const paramValue = typeof (a[1]) === 'undefined' ? true : a[1];
            if (obj[paramName]) {
                if (typeof obj[paramName] === 'string') {
                    obj[paramName] = d([obj[paramName]].toString());
                }
                if (typeof paramNum === 'undefined') {
                    obj[paramName].push(d(paramValue.toString()));
                } else {
                    obj[paramName][paramNum] = d(paramValue.toString());
                }
            } else {
                obj[paramName] = d(paramValue.toString());
            }
        }
    }
    return obj;
}

export function timeStampFormat(timestamp: number, format: string = "yyyy-MM-dd hh:mm:ss") {
    if (!timestamp) return '';
    // @ts-ignore
    return new Date(parseInt(timestamp) * 1000).format(format)
}

export function getTokenFromLocalCache(): string | null {
    return localStorage.getItem(TOKEN_KEY)
}

export function isEmpty(v: any) {
    return v === undefined || v === null || v === "";
}

export function stripLuaRichTextTags(str: string): string {
    return str.replace(/<.+?>/g, '');
}

export function checkIdNumber(idCard: string): boolean {
    if (!idCard) return false;
    let Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]; // 加权因子
    let ValideCode = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; // 身份证验证位值.10代表X

    function IdCardValidate(idCard: string) {
        idCard = idCard.replace(/ /g, "").trim(); //去掉字符串头尾空格
        if (idCard.length == 15) {
            return isValidityBrithBy15IdCard(idCard) //进行15位身份证的验证
        } else if (idCard.length == 18) {
            var a_idCard = idCard.split("") // 得到身份证数组
            if (isValidityBrithBy18IdCard(idCard) && isTrueValidateCodeBy18IdCard(a_idCard)) { //进行18位身份证的基本验证和第18位的验证
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }

    /**
     * 判断身份证号码为18位时最后的验证位是否正确
     * @param a_idCard 身份证号码数组
     * @return
     */
    function isTrueValidateCodeBy18IdCard(a_idCard: any[]) {
        var sum = 0; // 声明加权求和变量
        if (a_idCard[17].toLowerCase() == 'x') {
            a_idCard[17] = 10 // 将最后位为x的验证码替换为10方便后续操作
        }
        for (var i = 0; i < 17; i++) {
            sum += Wi[i] * a_idCard[i] // 加权求和
        }
        let valCodePosition = sum % 11 // 得到验证码所位置
        if (a_idCard[17] == ValideCode[valCodePosition]) {
            return true
        } else {
            return false
        }
    }

    /**
     * 验证18位数身份证号码中的生日是否是有效生日
     * @param idCard 18位书身份证字符串
     * @return
     */
    function isValidityBrithBy18IdCard(idCard18: string) {
        var year = idCard18.substring(6, 10);
        var month = idCard18.substring(10, 12);
        var day = idCard18.substring(12, 14);
        // @ts-ignore
        var temp_date = new Date(year, parseFloat(month) - 1, parseFloat(day));
        // 这里用getFullYear()获取年份，避免千年虫问题
        if (temp_date.getFullYear() != parseFloat(year) || temp_date.getMonth() != parseFloat(month) - 1 || temp_date.getDate() != parseFloat(day)) {
            return false
        } else {
            return true
        }
    }

    /**
     * 验证15位数身份证号码中的生日是否是有效生日
     * @param idCard15 15位书身份证字符串
     * @return
     */
    function isValidityBrithBy15IdCard(idCard15: string) {
        var year = idCard15.substring(6, 8);
        var month = idCard15.substring(8, 10);
        var day = idCard15.substring(10, 12);
        // @ts-ignore
        var temp_date = new Date(year, parseFloat(month) - 1, parseFloat(day));
        // 对于老身份证中的你年龄则不需考虑千年虫问题而使用getYear()方法
        // @ts-ignore
        if (temp_date.getYear() != parseFloat(year) || temp_date.getMonth() != parseFloat(month) - 1 || temp_date.getDate() != parseFloat(day)) {
            return false
        } else {
            return true
        }
    }

    return IdCardValidate(idCard)
}


export function regExpPhone(str: string) {
    return str && /^1\d{10}$/.test(str)
}

export function regExpAuthCode(str: string) {
    return str && /(^\d{4}$)/.test(str)
}

export function regExpPsw(str: string = "") {
    return str && /^[a-zA-Z0-9]{6,18}$/.test(str)
}

export function regExpEmail(str: string = "") {
    return str && new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$").test(str)
}

export function randomString(len: number = 5): string {
    let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    let maxPos = chars.length;
    let randomStr = '';
    for (let i = 0; i < len; i++) {
        randomStr += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return randomStr;
}

export function excelFormatDate(numb: number, format: string = "-"): string | null {
    try {
        let r = null
        const time = new Date((numb - 1) * 24 * 3600000 + 1)
        // @ts-ignore
        time.setYear(time.getFullYear() - 70);
        const year = time.getFullYear();
        const month = time.getMonth() + 1;
        const _date = time.getDate()
        const date = _date > 1 ? _date - 1 : _date;

        console.log(year, month, date)

        if (!year || !month || !date) {
            return null
        }

        if (format && format.length === 1) {
            return "" + year + format + month + format + date
        }
        // @ts-ignore
        return "" + year + (month < 10 ? '0' + month : month) + (date < 10 ? '0' + date : date)
    } catch (e) {
        return null
    }
}


export function loadImage(src: string): Promise<boolean> {
    return new Promise(resolve => {
        const image = new Image()
        image.onload = function () {
            resolve(true)
        }
        image.onerror = function () {
            resolve(false)
        }
        image.src = src;
    })
}


// 中室协机构后台
export function isCidaPartnerAdmin(): boolean {
    // return true;
    return window.location.host.startsWith("partner")
}

export function trim(v: any) {
    if (!v) return "";
    if (typeof v === "number") return String(v).trim();
    if (typeof v !== "string") return "";
    return v.trim()
}
